<div class="hmf-grid hmf-flex-wrap hmf-mt-m-xxxs">
  @for (trending of trendingArray; track trackByFn(arrIndex, trending); let arrIndex = $index; let isFirst = $first; let isLast = $last) {
    <div [ngClass]= "{
      'hmf-span-lg-6 hmf-span-xlg-3': trendingArray.length === 4,
      'hmf-span-xlg-4': trendingArray.length === 3,
      'hmf-span-xlg-6': trendingArray.length === 2,
      'hmf-pl-m-0 hmf-pr-m-s hmf-pr-0 hmf-mt-m-0 hmf-mt-xxxs': isFirst,
      'hmf-pr-0 hmf-pl-m-s hmf-pl-0': isLast,
      'hmf-px-m-xxs hmf-px-0': !(isFirst || isLast),
      'hmf-p-0': isMobile
      }"
      class="hmf-span-sm-12 hmf-span-md-6 hm-col trending">
      <div class="hmf-display-flex hmf-justify-content-center hmf-align-items-center">
        @if (trending?.image || trending?.visualAssets || trending?.youtubeId || trending?.animation) {
          <shared-media-component-media
            class="trending-img"
            [visualAssets]="trending?.visualAssets"
            [altText]="trending?.altText"
            [image]="trending?.image"
            [mobileImg]="trending?.mobileImg"
            [itemTitle]="trending?.headline"
            [youtubeId]="trending?.youtubeId"
            [animation]="trending?.animation"
            [imagePagePosition]="5"
            [willLazyLoad]="true">
          </shared-media-component-media>
        }
      </div>
      <div class="header hmf-display-flex hmf-justify-content-center" [ngClass]="{'pl-trending-header' : chain?.chainIdentifierAbbr === 'pl'}" [innerHTML]="trending?.headline | bypassSanitization"></div>
      @if (trending?.subCopy !== undefined) {
        <div class="meta hmf-display-flex hmf-justify-content-center" [ngClass]="{'pl-trending-copy' : chain?.chainIdentifierAbbr === 'pl'}"[innerHTML]="trending?.subCopy | bypassSanitization"></div>
      }
    </div>
  }
</div>
